'use client';

import type { DividerBlock } from '@impact/types';
import { cn } from '@/lib/utils';
import { DividerWave } from './divider-variants/Wave';
import { DividerGradientFade } from './divider-variants/GradientFade';

interface DividerBlockRendererProps {
  block: DividerBlock;
  editing?: boolean;
}

/**
 * Renders a visual divider/separator
 */
export function DividerBlockRenderer({ block, editing }: DividerBlockRendererProps) {
  switch (block.data.variant ?? 'default') {
    case 'wave':
      return <DividerWave block={block} editing={editing} />;
    case 'gradient-fade':
      return <DividerGradientFade block={block} editing={editing} />;
    default:
      break;
  }

  const { style = 'line' } = block.data;

  if (style === 'dots') {
    return (
      <div className="my-12 flex justify-center gap-2">
        <span className="h-2 w-2 rounded-full bg-muted-foreground/30" />
        <span className="h-2 w-2 rounded-full bg-muted-foreground/30" />
        <span className="h-2 w-2 rounded-full bg-muted-foreground/30" />
      </div>
    );
  }

  if (style === 'space') {
    return <div className="my-16" />;
  }

  // Line style (default)
  return <hr className={cn('my-12 border-t border-border')} />;
}
